import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ChevronIcon from '../../assets/icons/chevron.svg?react';
import styles from './LocationCard.module.css';

interface LocationCardProps {
  id: string;
  name: string;
}

export const LocationCard = ({ id, name }: LocationCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/locations/${encodeURIComponent(id)}/year-overview`);
  };

  return (
    <div className={styles.card}>
      <span className={styles.name}>{name}</span>
      <button className={styles.button} onClick={handleClick}>
        {t('go-to-center')} <ChevronIcon className={styles.chevron} />
      </button>
    </div>
  );
};
